// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"lJ-z","carousel":"mJ-z"};